import { useProfileData } from './useProfileData';

export const useAgentData = () => {
  const { data, loading, error, refetch } = useProfileData();

  return {
    agentData: data,
    loading,
    error,
    refetch
  };
};